module.exports = __webpack_public_path__ + "static/giftstogive-2a22260d694a98ccc07a4a82cecb40f2.jpg";